import React from 'react'
import Hero from './Hero'
import Brokrej from './Brokrej'
import AccountCharge from './AccountCharge'

function PricingPage() {
    return (
        <>
        <Hero/>
        <Brokrej/>
        <AccountCharge/>
        </>
    )
}

export default PricingPage
